'use client';

import React, { useState } from 'react';
import { VideoModal, VideoModalState } from 'sailor-ui/VideoModal';
import styles from '../../styles/Home.module.scss';

const theBoatAppManagementVideoUrl =
  'https://www.youtube.com/embed/-ReAAleoVHI?autoplay=1&controls=1&enablejsapi=1&html5=1';

const VideoModalClient: React.FC = () => {
  const [isModalVisible, setIsModalVisible] = useState<VideoModalState>('NOT_OPENED');

  const showVideoModal = (): void => {
    setIsModalVisible('OPEN');
  };

  const closeVideoModal = (): void => {
    setIsModalVisible('CLOSED');
  };

  return (
    <>
      <button title="Click to Play" type="button" onClick={showVideoModal} className={styles.SectionImage_PlayBtn}>
        <img src="/images/play-btn.svg" alt="play-btn" />
      </button>
      <VideoModal
        isModalVisible={isModalVisible}
        closeVideoModal={closeVideoModal}
        src={theBoatAppManagementVideoUrl}
      />
    </>
  );
};

export default VideoModalClient;
